import React, {useEffect, useRef, useState} from "react"
import {layoutSidebarLeftWidth} from "../settings"
import {hasUrlFlag,getUrlFlagValue, URL_FLAG__LIGHTVERSION, URL_FLAG__ROOM_L,URL_FLAG__ROOM_W,URL_FLAG__ROOM_H, URL_FLAG__SKIP_SHAPE} from "../Helper/UrlFlag"
import {iconEdit, iconSettings} from "../Helper/Icons"
import {shapes} from "./Shape/Shapes"
import {useHelp, useRoomParameters, useRoomSetup, useLocal, useSolution, useMessage, useProgress} from "../AppContext"
import {useSidebar} from "../Hooks/Sidebar"
import {CtaBubble, CtaBubbleLabel} from "../Components/CtaBubble"
import {InputSelect, InputSize} from "../Components/Input"
import {MenuLeft} from "../Components/MenuLeft"
import {SelectItemAlignCenter} from "../Components/Menu/SelectItem"
import {SideBarRightBody, SideBarRightBodyBlock, SideBarRightBodyBlockLabel, SideBarRightBodyBlockLabelHighlight, SideBarRightHead, SideBarRightHeadItem, SideBarRightLayout, SideBarRightSectionLabel10, SideBarRightSectionLabel20} from "../Components/SideBar/SideBarRight";
import {SideBarRightHandel} from "../Components/SideBar/SideBarRightHandel"
import style from "./Shape.css"

export const Shape = () => {
    const local = useLocal()
    const roomParameters = useRoomParameters()
    const help = useHelp()
    const roomSetup = useRoomSetup()
    const sidebar = useSidebar()
    const [zoom, setZoom] = useState(true)
    const lightversion = hasUrlFlag(URL_FLAG__LIGHTVERSION)

    useEffect(() => {
        roomSetup.unsetHandle()
        help.setContext('grundriss')

        if (!roomSetup.hasDimensions()) {
            roomSetup.setDimensions(roomParameters.getDimensions(roomSetup.getShape(), roomSetup.getType()))
        }
    }, [])

    return <>
        <MenuLeft label={local.__("Gundriss")} callbackStatus={setZoom}>
            <Shapes/>
        </MenuLeft>
        <ShapeMap sidebar={sidebar} zoom={!zoom}/>
        <Properties sidebar={sidebar}/>
        <CtaBubble name={"shape"} left={layoutSidebarLeftWidth + 40} top={155}>
            <CtaBubbleLabel>
                {local.__("Gundriss")}
            </CtaBubbleLabel>
            <div dangerouslySetInnerHTML={{__html: local.__("Bitte wählen sie ihre Raumform")}}/>
        </CtaBubble>
    </>
}

const Shapes = () => {
    const roomParameters = useRoomParameters()
    const progress = useProgress()
    const lightversion = hasUrlFlag(URL_FLAG__LIGHTVERSION)
    const roomSetup = useRoomSetup()
    const skipshape = hasUrlFlag(URL_FLAG__SKIP_SHAPE);
    var roomList = roomParameters.getRoomShapes();
    
    if (skipshape){
        // Fill default parameters
        roomSetup.setWallConstitution('wall-stone')
        roomSetup.setFloorConstitution('floor-tiles')
        roomSetup.setCeilingConstitution('ceiling-concrete')
        // Remove url parameter, only for the first load needed
        var parameter = URL_FLAG__SKIP_SHAPE;
        var url = new URL(window.location.href)+'';
        var urlparts= url.split('?');   
          
          if (urlparts.length>=2) {
              var prefix= encodeURIComponent(parameter)+'=';
              var pars= urlparts[1].split(/[&;]/g);
              
              //reverse iteration as may be destructive
              for (var i= pars.length; i-- > 0;) {    
                  //idiom for string.startsWith
                  var testvar = pars[i]+" ";
                  if (testvar.lastIndexOf(prefix, 0) !== -1) {  
                      pars.splice(i, 1);
                  }
              }
              url= urlparts[0] + (pars.length > 0 ? '?' + pars.join('&') : "");
              window.history.pushState({}, '', url.toString());
          }
        progress.gotoSolution()
    }
    if (lightversion){
      const allowedCodeNames = ['rectangle', 'l_form_a', 'pentagonal_a'];
      roomList = roomList.filter(shape => allowedCodeNames.includes(shape.code));
      
    }
    return roomList.map(shape => <Item key={shape.code} shape={shape}/>)
}

const Item = ({shape}) => {
    const roomParameters = useRoomParameters()
    const roomSetup = useRoomSetup()
    const local = useLocal()
    const solution = useSolution()
    const message = useMessage()
    const isActive = shape.code === roomSetup.getShape()

    const onClick = () => {
        const action = () => {
            solution.reset()
            roomSetup.setShape(shape.code)
            roomSetup.setDimensions(roomParameters.getDimensions(shape.code, roomSetup.getType()))
        }

        if (solution.countPlannings()) {
            message.showPrompt(local.__("Änderungen am Grundriss bewirken das zurücksetzen aller Planungen.<br/>Möchten Sie Ihre Planungen verwerfen und fortfahren?"), action)
        } else {
            action()
        }
    }

    return <SelectItemAlignCenter onClick={onClick} isActive={isActive}>
        <div className={style.item}>
            <div>
                <div>{local.getLabel(shape.name)}</div>
                <div>{local.getLabel(shape.description)}</div>
            </div>
            <svg viewBox="0 0 50 50">
                <path d={shapes[shape.code].icon}/>
            </svg>
        </div>
    </SelectItemAlignCenter>
}

const ShapeMap = ({sidebar, zoom}) => {
    const roomSetup = useRoomSetup()
    const shape = shapes[roomSetup.getShape()]
    const refB1 = useRef()
    const refB2 = useRef()
    const [box, setBox] = useState({left: 0, top: 0, right: 0, bottom: 0, width: 0, height: 0, width25: 0, width50: 0, width75: 0, height25: 0, height50: 0, height75: 0})

    let container = style.container
    if (zoom && !sidebar.isOpen()) container = style.containerFull
    else if (zoom) container = style.containerLeft
    else if (!sidebar.isOpen()) container = style.containerRight

    useEffect(() => {
        const interval = setInterval(() => {
            const b1 = refB1.current.getBoundingClientRect()
            const b2 = refB2.current.getBoundingClientRect()

            setBox({
                left: (b2.x - b1.x),
                top: (b2.y - b1.y),
                right: ((b1.x + b1.width) - (b2.x + b2.width)),
                bottom: ((b1.y + b1.height) - (b2.y + b2.height)),
                width: b2.width,
                width25: b2.width * 0.25,
                width50: b2.width * 0.5,
                width75: b2.width * 0.75,
                height: b2.height,
                height25: b2.height * 0.25,
                height50: b2.height * 0.5,
                height75: b2.height * 0.75,
            })
        }, 300)

        return () => clearInterval(interval)
    }, [])

    return <div className={container}>
        <div ref={refB1} className={style.shape}>
            <svg width={"100%"} height={"100%"} viewBox={shape.viewBox}>
                <defs>
                    <pattern id="pattern" x="0" y="0" width="50" height="50" patternUnits="userSpaceOnUse" patternTransform={shape.patternTransform}>
                        <line id="l" x1="25" y1="50" x2="25" y2="0"/>
                    </pattern>
                </defs>
                <path ref={refB2} d={shape.path} fill={"url(#pattern)"}/>
            </svg>
            <Size shape={roomSetup.getShape()} box={box} sidebar={sidebar}/>
        </div>
    </div>
}

const Size = ({box, sidebar}) => {
    const local = useLocal()
    const roomSetup = useRoomSetup()
    const solution = useSolution()
    const message = useMessage()

    let v = [];

    if (roomSetup.getShape() === "rectangle") {
        v.push({
            dimension: "a",
            label: "A",
            value: roomSetup.getDimensions().a,
            style: {
                left: `${box.left + box.width50}px`,
                top: `${box.top}px`,
                transform: "translate(-50%, 025px)"
            }
        })

        v.push({
            dimension: "b",
            label: "B",
            value: roomSetup.getDimensions().b,
            style: {
                right: `${box.right}px`,
                top: `${box.top + box.height50}px`,
                transform: "translate(-25px, -50%)"
            }
        })
    }

    if (roomSetup.getShape() === "open") {
        v.push({
            dimension: "a",
            label: "A",
            value: roomSetup.getDimensions().a,
            style: {
                left: `${box.left + box.width50}px`,
                top: `${box.top}px`,
                transform: "translate(-50%, 025px)"
            }
        })

        v.push({
            dimension: "b",
            label: "B",
            value: roomSetup.getDimensions().b,
            style: {
                right: `${box.right}px`,
                top: `${box.top + box.height50}px`,
                transform: "translate(-25px, -50%)"
            }
        })

        v.push({
            dimension: "c",
            label: "C",
            value: roomSetup.getDimensions().c,
            style: {
                left: `${box.left}px`,
                top: `${box.top + box.height50}px`,
                transform: "translate(25px, -50%)"
            }
        })
    }

    if (roomSetup.getShape() === "l_form_a") {
        v.push({
            dimension: "a",
            label: "A",
            value: roomSetup.getDimensions().a,
            style: {
                left: `${box.left + box.width25}px`,
                top: `${box.top}px`,
                transform: "translate(-50%, 25px)"

            }
        })

        v.push({
            dimension: "b",
            label: "B",
            value: roomSetup.getDimensions().b,
            style: {
                right: `${box.right}px`,
                top: `${box.top + box.height75}px`,
                transform: "translate(-25px, -50%)"

            }
        })

        v.push({
            dimension: "c",
            label: "C",
            value: roomSetup.getDimensions().c,
            style: {
                left: `${box.left + box.width50}px`,
                bottom: `${box.bottom}px`,
                transform: "translate(-50%, -25px)"
            }
        })

        v.push({
            dimension: "d",
            label: "D",
            value: roomSetup.getDimensions().d,
            style: {
                left: `${box.left}px`,
                top: `${box.top + box.height50}px`,
                transform: "translate(+25px, -50%)"
            }
        })
    }

    if (roomSetup.getShape() === "l_form_b") {
        v.push({
            dimension: "a",
            label: "A",
            value: roomSetup.getDimensions().a,
            style: {
                left: `${box.left + box.width75}px`,
                top: `${box.top}px`,
                transform: "translate(-50%, 25px)"

            }
        })

        v.push({
            dimension: "b",
            label: "B",
            value: roomSetup.getDimensions().b,
            style: {
                right: `${box.right}px`,
                top: `${box.top + box.height50}px`,
                transform: "translate(-25px, -50%)"
            }
        })

        v.push({
            dimension: "c",
            label: "C",
            value: roomSetup.getDimensions().c,
            style: {
                left: `${box.left + box.width50}px`,
                bottom: `${box.bottom}px`,
                transform: "translate(-50%, -25px)"
            }
        })

        v.push({
            dimension: "d",
            label: "D",
            value: roomSetup.getDimensions().d,
            style: {
                left: `${box.left}px`,
                top: `${box.top + box.height75}px`,
                transform: "translate(+25px, -50%)"
            }
        })
    }

    if (roomSetup.getShape() === "l_form_c") {
        v.push({
            dimension: "a",
            label: "A",
            value: roomSetup.getDimensions().a,
            style: {
                left: `${box.left + box.width50}px`,
                top: `${box.top}px`,
                transform: "translate(-50%, 25px)"
            }
        })

        v.push({
            dimension: "b",
            label: "B",
            value: roomSetup.getDimensions().b,
            style: {
                right: `${box.right}px`,
                top: `${box.top + box.height25}px`,
                transform: "translate(-25px, -50%)"
            }
        })

        v.push({
            dimension: "c",
            label: "C",
            value: roomSetup.getDimensions().c,
            style: {
                left: `${box.left + box.width25}px`,
                bottom: `${box.bottom}px`,
                transform: "translate(-50%, -25px)"
            }
        })

        v.push({
            dimension: "d",
            label: "D",
            value: roomSetup.getDimensions().d,
            style: {
                left: `${box.left}px`,
                top: `${box.top + box.height50}px`,
                transform: "translate(+25px, -50%)"
            }
        })
    }

    if (roomSetup.getShape() === "l_form_d") {
        v.push({
            dimension: "a",
            label: "A",
            value: roomSetup.getDimensions().a,
            style: {
                left: `${box.left + box.width50}px`,
                top: `${box.top}px`,
                transform: "translate(-50%, 25px)"
            }
        })

        v.push({
            dimension: "b",
            label: "B",
            value: roomSetup.getDimensions().b,
            style: {
                right: `${box.right}px`,
                top: `${box.top + box.height50}px`,
                transform: "translate(-25px, -50%)"
            }
        })

        v.push({
            dimension: "c",
            label: "C",
            value: roomSetup.getDimensions().c,
            style: {
                left: `${box.left + box.width75}px`,
                bottom: `${box.bottom}px`,
                transform: "translate(-50%, -25px)"
            }
        })

        v.push({
            dimension: "d",
            label: "D",
            value: roomSetup.getDimensions().d,
            style: {
                left: `${box.left}px`,
                top: `${box.top + box.height25}px`,
                transform: "translate(+25px, -50%)"
            }
        })
    }

    if (roomSetup.getShape() === "pentagonal_a") {
        v.push({
            dimension: "a",
            label: "A",
            value: roomSetup.getDimensions().a,
            style: {
                left: `${box.left + box.width25}px`,
                top: `${box.top}px`,
                transform: "translate(-50%, 25px)"
            }
        })

        v.push({
            dimension: "b",
            label: "B",
            value: roomSetup.getDimensions().b,
            style: {
                right: `${box.right}px`,
                top: `${box.top + box.height75}px`,
                transform: "translate(-25px, -50%)"
            }
        })

        v.push({
            dimension: "c",
            label: "C",
            value: roomSetup.getDimensions().c,
            style: {
                left: `${box.left + box.width50}px`,
                bottom: `${box.bottom}px`,
                transform: "translate(-50%, -25px)"
            }
        })

        v.push({
            dimension: "d",
            label: "D",
            value: roomSetup.getDimensions().d,
            style: {
                left: `${box.left}px`,
                top: `${box.top + box.height50}px`,
                transform: "translate(+25px, -50%)"
            }
        })
    }

    if (roomSetup.getShape() === "pentagonal_b") {
        v.push({
            dimension: "a",
            label: "A",
            value: roomSetup.getDimensions().a,
            style: {
                left: `${box.left + box.width75}px`,
                top: `${box.top}px`,
                transform: "translate(-50%, 25px)"
            }
        })

        v.push({
            dimension: "b",
            label: "B",
            value: roomSetup.getDimensions().b,
            style: {
                right: `${box.right}px`,
                top: `${box.top + box.height75}px`,
                transform: "translate(-25px, -50%)"
            }
        })

        v.push({
            dimension: "c",
            label: "C",
            value: roomSetup.getDimensions().c,
            style: {
                left: `${box.left + box.width50}px`,
                bottom: `${box.bottom}px`,
                transform: "translate(-50%, -25px)"
            }
        })

        v.push({
            dimension: "d",
            label: "D",
            value: roomSetup.getDimensions().d,
            style: {
                left: `${box.left}px`,
                top: `${box.top + box.height75}px`,
                transform: "translate(+25px, -50%)"
            }
        })
    }

    if (roomSetup.getShape() === "pentagonal_c") {
        v.push({
            dimension: "a",
            label: "A",
            value: roomSetup.getDimensions().a,
            style: {
                left: `${box.left + box.width50}px`,
                top: `${box.top}px`,
                transform: "translate(-50%, 25px)"
            }
        })

        v.push({
            dimension: "b",
            label: "B",
            value: roomSetup.getDimensions().b,
            style: {
                right: `${box.right}px`,
                top: `${box.top + box.height25}px`,
                transform: "translate(-25px, -50%)"
            }
        })

        v.push({
            dimension: "c",
            label: "C",
            value: roomSetup.getDimensions().c,
            style: {
                left: `${box.left + box.width25}px`,
                bottom: `${box.bottom}px`,
                transform: "translate(-50%, -25px)"
            }
        })

        v.push({
            dimension: "d",
            label: "D",
            value: roomSetup.getDimensions().d,
            style: {
                left: `${box.left}px`,
                top: `${box.top + box.height50}px`,
                transform: "translate(+25px, -50%)"
            }
        })
    }

    if (roomSetup.getShape() === "pentagonal_d") {
        v.push({
            dimension: "a",
            label: "A",
            value: roomSetup.getDimensions().a,
            style: {
                left: `${box.left + box.width50}px`,
                top: `${box.top}px`,
                transform: "translate(-50%, 25px)"
            }
        })

        v.push({
            dimension: "b",
            label: "B",
            value: roomSetup.getDimensions().b,
            style: {
                right: `${box.right}px`,
                top: `${box.top + box.height50}px`,
                transform: "translate(-25px, -50%)"
            }
        })

        v.push({
            dimension: "c",
            label: "C",
            value: roomSetup.getDimensions().c,
            style: {
                left: `${box.left + box.width75}px`,
                bottom: `${box.bottom}px`,
                transform: "translate(-50%, -25px)"
            }
        })

        v.push({
            dimension: "d",
            label: "D",
            value: roomSetup.getDimensions().d,
            style: {
                left: `${box.left}px`,
                top: `${box.top + box.height25}px`,
                transform: "translate(+25px, -50%)"
            }
        })
    }

    return v.map((prop, index) => {
        const onClick = () => {
            const id = `dimension_${prop.dimension}`
            if (document.getElementById(id)) {
                sidebar.open()
                document.getElementById(id).focus()
                document.getElementById(id).select()
            }
        }

        const onChange = (event) => {
            const action = () => {
                solution.reset()
                roomSetup.setDimension(prop.dimension, event.target.value)
            }

            if (solution.countPlannings()) {
                message.showPrompt(local.__("Änderungen an den Abmessunge bewirken das zurücksetzen aller Planungen.<br/>Möchten Sie Ihre Planungen verwerfen und fortfahren?"), action)
            } else {
                action()
            }
        }

        return <div key={index} style={prop.style} className={style.size} onClick={onClick}>
            <div>{prop.label}</div>
            <InputSize value={prop.value ? prop.value : ""} onChange={onChange} id={`dimension_${prop.dimension}`}/>
            {local.__("cm")}
            {iconEdit}
        </div>
    })
}

const Properties = ({sidebar}) => {
    const roomSetup = useRoomSetup()
    const local = useLocal()
    const lightversion = hasUrlFlag(URL_FLAG__LIGHTVERSION)
    
    const open = () => {
        sidebar.open()
    }

    useEffect(() => {
        open()
    }, [roomSetup.getShape()])
    
    if (lightversion){
        roomSetup.setWallConstitution('wall-stone')
        roomSetup.setFloorConstitution('floor-tiles')
        roomSetup.setCeilingConstitution('ceiling-concrete')
        if (!roomSetup.isCeilingUsable()) {
          roomSetup.toggleCeilingUsable()
        }
        return <SideBarRightHandel sidebar={sidebar}>
        <SideBarRightLayout>
            <SideBarRightHead>
                <SideBarRightHeadItem isActive={sidebar.isOpen()} icon={iconSettings} label={local.__("Raumeinstellungen")} onClick={open}/>
            </SideBarRightHead>
            <SideBarRightBody isOpen={sidebar.isOpen()}>
                <SideBarRightSectionLabel10 label={local.__("Maße")}/>
                <Dimensions/>
                
            </SideBarRightBody>
        </SideBarRightLayout>
      </SideBarRightHandel>
    
    }
    
    
    return <SideBarRightHandel sidebar={sidebar}>
        <SideBarRightLayout>
            <SideBarRightHead>
                <SideBarRightHeadItem isActive={sidebar.isOpen()} icon={iconSettings} label={local.__("Raumeinstellungen")} onClick={open}/>
            </SideBarRightHead>
            <SideBarRightBody isOpen={sidebar.isOpen()}>
                <SideBarRightSectionLabel10 label={local.__("Maße")}/>
                <Dimensions/>
                <SideBarRightSectionLabel20 label={local.__("Materialien")}/>
                <CeilingConstitution/>
                <WallConstitution/>
                <FloorConstitution/>
            </SideBarRightBody>
        </SideBarRightLayout>
    </SideBarRightHandel>
}

const Dimensions = () => {
    const roomSetup = useRoomSetup()
    const dimensions = Object.keys(roomSetup.getDimensions())
    
    if (hasUrlFlag(URL_FLAG__ROOM_H)){
        roomSetup.getDimensions().height=parseInt(getUrlFlagValue(URL_FLAG__ROOM_H));
    }
    if (hasUrlFlag(URL_FLAG__ROOM_W)){
        roomSetup.getDimensions().b=parseInt(getUrlFlagValue(URL_FLAG__ROOM_W));
    }
    if (hasUrlFlag(URL_FLAG__ROOM_L)){
        roomSetup.getDimensions().a=parseInt(getUrlFlagValue(URL_FLAG__ROOM_L)); 
    }   
    return dimensions.map(dimension => <Dimension key={dimension} dimension={dimension}/>)
}

const Dimension = ({dimension}) => {
    const roomSetup = useRoomSetup()
    const solution = useSolution()
    const message = useMessage()
    const local = useLocal()
    const value = roomSetup.getDimensions()[dimension]

    const onChange = (event) => {
        const action = () => {
            solution.reset()
            roomSetup.setDimension(dimension, event.target.value)
        }

        if (solution.countPlannings()) {
            message.showPrompt(local.__("Änderungen an den Abmessunge bewirken das zurücksetzen aller Planungen.<br/>Möchten Sie Ihre Planungen verwerfen und fortfahren?"), action)
        } else {
            action()
        }
    }

    return <SideBarRightBodyBlock>
        <DimensionLabel dimension={dimension} value={value}/>
        <InputSize value={value ? value : ""} onChange={onChange}/>
    </SideBarRightBodyBlock>
}

const DimensionLabel = ({dimension, value}) => {
    const local = useLocal()

    if (dimension === "height") {
        return <SideBarRightBodyBlockLabel>
            <SideBarRightBodyBlockLabelHighlight>{local.__("Raumhöhe")}</SideBarRightBodyBlockLabelHighlight>
            &nbsp;
            {/*{local.__("in cm (%value% m)", {value: value ? value / 100 : 0})}*/}
            {local.__("in cm", {value: value ? value / 100 : 0})}
        </SideBarRightBodyBlockLabel>
    }

    return <SideBarRightBodyBlockLabel>
        {local.__("Länge")}
        &nbsp;
        <SideBarRightBodyBlockLabelHighlight>{dimension.toUpperCase()}</SideBarRightBodyBlockLabelHighlight>
        &nbsp;
        {/*{local.__("in cm (%value% m)", {value: value ? value / 100 : 0})}*/}
        {local.__("in cm", {value: value ? value / 100 : 0})}
    </SideBarRightBodyBlockLabel>
}

const WallConstitution = () => {
    const local = useLocal()
    const roomParameters = useRoomParameters()
    const roomSetup = useRoomSetup()
    const options = roomParameters.getWallConstitutions()
    const value = roomSetup.getWallConstitution()
    const lightversion = hasUrlFlag(URL_FLAG__LIGHTVERSION)

    const onChange = (event) => {
        roomSetup.setWallConstitution(event.target.value)
    }
    
    if (lightversion){
      roomSetup.setWallConstitution('wall-stone')
      return null
    }

    return <SideBarRightBodyBlock>
        <SideBarRightBodyBlockLabel label={local.__("Wandbeschaffenheit")}/>
        <InputSelect local={local} options={options} value={value} onChange={onChange}/>
    </SideBarRightBodyBlock>
}

const FloorConstitution = () => {
    const local = useLocal()
    const roomParameters = useRoomParameters()
    const roomSetup = useRoomSetup()
    const options = roomParameters.getFloorConstitutions()
    const value = roomSetup.getFloorConstitution()
    const lightversion = hasUrlFlag(URL_FLAG__LIGHTVERSION)

    const onChange = (event) => {
        roomSetup.setFloorConstitution(event.target.value)
    }

    if (lightversion){
      roomSetup.setFloorConstitution('floor-tiles')
      return null
    }
    
    return <SideBarRightBodyBlock>
        <SideBarRightBodyBlockLabel label={local.__("Bodenbeschaffenheit")}/>
        <InputSelect local={local} options={options} value={value} onChange={onChange}/>
    </SideBarRightBodyBlock>
}

const CeilingConstitution = () => {
    
    
    const local = useLocal()
    const roomParameters = useRoomParameters()
    const roomSetup = useRoomSetup()
    const options = roomParameters.getCeilingConstitutions()
    const value = roomSetup.getCeilingConstitution()
    const lightversion = hasUrlFlag(URL_FLAG__LIGHTVERSION)
    const onChange = (event) => {
        roomSetup.setCeilingConstitution(event.target.value)
    }
    
    if (lightversion){
      roomSetup.setCeilingConstitution('ceiling-concrete')
      return null
    }
    
    return <SideBarRightBodyBlock>
        <SideBarRightBodyBlockLabel label={local.__("Deckenbeschaffenheit")}/>
        <InputSelect local={local} options={options} value={value} onChange={onChange}/>
    </SideBarRightBodyBlock>  
    
}
